import React, { useState, useEffect, useRef } from "react";

const API_URL = "https://apisix.lazyinwork.com:9443/api/v1";
const AGENT_ID = "7dda03e0ee5711ef871a0242ac120005";
const API_KEY = "theta_wang-here";

const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const chatEndRef = useRef(null);

  useEffect(() => {
      createSession();
  }, []);

  const createSession = async () => {
      try {
          const response = await fetch(`${API_URL}/agents/${AGENT_ID}/sessions`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "app": `ragflow_serv`,
                  "apikey": API_KEY
              },
              body: JSON.stringify({})
          });
          const data = await response.json();
          if (data.code === 0) {
              await setSessionId(data.data.id);
              setMessages([{ role: "assistant", content: "已經為您連接上論證助理，可以開始進行溝通。" }]);
          }
          
      } catch (error) {
          console.error("Error creating session:", error);
      }
  };

  const sendMessage = async () => {
      if (!input.trim()) return;
      
      const userMessage = { role: "user", content: input };
      setMessages(prev => [...prev, userMessage]);
      setInput("");

      try {
          const response = await fetch(`${API_URL}/agents/${AGENT_ID}/completions`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "app": `ragflow_serv`,
                  "apikey": API_KEY
              },
              body: JSON.stringify({
                  question: input,
                  stream: false,
                  session_id: sessionId
              })
          });
          
          const data = await response.json();
          if (data.code === 0) {
              setMessages(prev => [...prev, { role: "assistant", content: data.data.answer }]);
          }
      } catch (error) {
          console.error("Error sending message:", error);
      }
  };

  useEffect(() => {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
      <div className="chat-container" style={{ maxWidth: "500px", margin: "auto", padding: "20px", border: "1px solid #ddd", borderRadius: "8px" }}>
          <div className="chat-box" style={{ height: "400px", overflowY: "auto", padding: "10px", background: "var(--surface-color)" }}>
              {messages.map((msg, index) => (
                  <div key={index} style={{
                      textAlign: msg.role === "user" ? "right" : "left",
                      margin: "10px 0"
                  }}>
                      <div style={{
                          display: "inline-block",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          background: msg.role === "user" ? "#007bff" : "#e5e5e5",
                          color: msg.role === "user" ? "#fff" : "#000"
                      }}>
                          {msg.content}
                      </div>
                  </div>
              ))}
              <div ref={chatEndRef} />
          </div>
          <div className="chat-input" style={{ marginTop: "10px", display: "flex" }}>
              <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && sendMessage()}
                  style={{ flex: 1, padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
              />
              <button onClick={sendMessage} style={{ marginLeft: "5px", padding: "10px", background: "var(--secondary-color)", color: "var(--white)", border: "none", borderRadius: "var(--border-radius-sm)" }}>發送</button>
          </div>
      </div>
  );
};


const CallAgent = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(true);
  };

  return (
            <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000, backgroundColor: 'var(--white)', borderRadius: 'var(--border-radius-lg)', padding: '20px', boxShadow: 'var(--shadow-lg)' }}>
      {isOpen ? (
        <div>            
            <button
                onClick={()=>{setIsOpen(false)}}
                style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: '#ff5f5f',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
                }}
            >
                ✖
            </button>
            <Chatbot/>
        </div>
    ) : (
        <div
          onClick={handleClick}
          style={{
            width: '10px',
            height: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: '#f0f0f0',
            borderRadius: '50%',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
          }}
        >
          📞
        </div>
      )}
    </div>
  );
};

export default CallAgent;
